<template>
  <div class="head_top">
    <!-- <el-button type="info" @click="logonOut('loginForm')" round>退出</el-button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  methods: {
    logonOut() {
      sessionStorage.setItem("logon", 0);
      this.$message({
        type: "success",
        message: "退出成功",
      });
      this.$router.push("/");
    },
  },
};
</script>
<style lang="less" scoped>
@import "../style/common";
@import "../style/mixin";
.head_top {
  display: flex;
  justify-content: space-between;
}
.head_top_breadcrumb {
  text-align: center;
  line-height: 40px;
  font-size: 25px;
  padding: 0 0 0 15px;
}
// .head_top_breadcrumb /deep/ .el-breadcrumb__inner {
//   color: #fff !important;
// }
.el-button {
  color: #fff;
  font-size: 25px;
  text-align: right;
  margin: 5px;
}
</style>
